import { render, staticRenderFns } from "./StudioMapChip.vue?vue&type=template&id=aafb4e9e&scoped=true"
import script from "./StudioMapChip.vue?vue&type=script&lang=ts&setup=true"
export * from "./StudioMapChip.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./StudioMapChip.vue?vue&type=style&index=0&id=aafb4e9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aafb4e9e",
  null
  
)

export default component.exports